// extracted by mini-css-extract-plugin
module.exports = {"container":"document-toolkit-main_container__NxQZc","hero":"document-toolkit-main_hero__egth1","card":"document-toolkit-main_card__FHZN7"};